module.exports = __webpack_public_path__ + "static/img/upgrade-log-bg.6fc165e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/images/upgrade-log-bg.png
// module id = btUp
// module chunks = 6